import type { Dispatch, SetStateAction } from 'react'

import { Button } from '@/components/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/dialog'

export interface ConfirmDeleteDialogProps {
  onConfirmDelete: () => void
  onClose: () => void
  text: string
  open: boolean
  openChange: Dispatch<SetStateAction<boolean>>
  isLoadingProofDelete: boolean
}

export function ConfirmDeleteDialog({
  onConfirmDelete,
  onClose,
  text,
  open,
  openChange,
  isLoadingProofDelete,
}: ConfirmDeleteDialogProps) {
  return (
    <Dialog open={open} onOpenChange={openChange}>
      <DialogContent className="h-auto max-w-96">
        <DialogHeader>
          <DialogTitle>Confirmar exclusão?</DialogTitle>
          <DialogDescription>{text}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="tertiary" onClick={onClose} className="w-full">
            Não
          </Button>

          <Button
            onClick={onConfirmDelete}
            className="w-full"
            disabled={isLoadingProofDelete}
            isSubmitting={isLoadingProofDelete}
          >
            Sim
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
